export const DatePickerStyle = {
  '.MuiButtonBase-root': {
    outline: 'none !important',
  },
  '.Mui-selected': {
    backgroundColor: 'var(--theme-primary, #810ea9) !important',
  },
  '.MuiPickersDay-today': {
    border: '1px solid var(--theme-primary, #810ea9) !important',
  },
  '.MuiPickersCalendarHeader-labelContainer': {
    marginRight: '1em',
  },
  '.MuiPickersArrowSwitcher-root': {
    flexDirection: 'row-reverse',
    alignSelf: 'normal',
    float: 'left',
    marginRight: 'auto',
  },
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--theme-primary, #810ea9) !important',
  },
  '.Mui-error': {
    borderColor: 'var(--theme-primary, #810ea9) !important',
  },
};
